import type { AnonymousRecordUploadStatus } from './anonymous-record-upload-status';

export const EFAX_DISPLAY_STATUS_OPTIONS: Array<{
  value: AnonymousRecordUploadStatus;
  label: string;
}> = [
  { value: 'identifying', label: 'Identifying' },
  { value: 'processing', label: 'Processing' },
  { value: 'completed', label: 'Completed' },
  { value: 'error', label: 'Error' },
];

export const EFAX_STATUS_FILTER_OPTIONS = [
  { value: '', label: 'Any Status' },
  ...EFAX_DISPLAY_STATUS_OPTIONS,
] as const;

export type EfaxStatusFilterValue =
  (typeof EFAX_STATUS_FILTER_OPTIONS)[number]['value'];

export const isEfaxIdentifying = (status: AnonymousRecordUploadStatus) =>
  status === 'identifying';

export const isEfaxProcessing = (status: AnonymousRecordUploadStatus) =>
  status === 'processing';

export const isEfaxCompleted = (status: AnonymousRecordUploadStatus) =>
  status === 'completed';

export const isEfaxError = (status: AnonymousRecordUploadStatus) =>
  status === 'error';

export const isEfaxProcessingOrCompleted = (
  status: AnonymousRecordUploadStatus,
) => isEfaxProcessing(status) || isEfaxCompleted(status);
